<template>
  <BaseDialog centered contentClass="add-opportunity-label" ref="dialog" :show-actions="true">
    <template slot="title">{{ $t('page.admin-opportunity-labels.add-dialog.title') }}</template>
    <template slot="content">
      <form @click.prevent @keydown.enter.prevent>
        <div>
          <FormInput
            ref="labelNameValue"
            :label="$t('page.admin-opportunity-labels.add-dialog.name')"
            is-required
            has-gray-background
            name="name"
            type="name"
            v-model="labelName"
            v-validate="'required'"
          />
          <FormInput
            :label="$t('page.admin-opportunity-labels.add-dialog.description')"
            is-required
            has-gray-background
            name="description"
            v-model="labelDescription"
            v-validate="'required'"
          />
          <FormColorPicker
            :label="$t('page.admin-opportunity-labels.add-dialog.color')"
            v-model="labelColor"
            is-required
          />
        </div>
        <div class="add-opportunity-label__actions">
          <FormButton is-outlined class="add-opportunity-label__cancel" @click.native="cancelClick">{{
            $t('actions.cancel')
          }}</FormButton>
          <FormButton @click.native="onSubmit" type="submit" :disabled="isFormInvalid">
            <span>{{ $t('actions.save') }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';
import { mapActions } from 'vuex';
import FormColorPicker from '@/components/form/FormColorPicker.vue';

export default {
  name: 'AddOpportunityLabelDialog',
  components: {
    FormColorPicker,
    BaseDialog,
    FormButton,
    FormInput,
  },
  data() {
    return {
      labelName: '',
      labelDescription: '',
      labelColor: '',
    };
  },
  computed: {
    isFormInvalid() {
      return !this.labelName || !this.labelDescription || !this.labelColor;
    },
  },
  methods: {
    ...mapActions('opportunityLabels', ['addOpportunityLabel']),
    openDialog() {
      this.labelName = '';
      this.labelDescription = '';
      this.labelColor = '#000000';
      this.$refs.dialog.openModal();

      this.$nextTick(() => {
        const refInput = this.$refs.labelNameValue.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => {
            refInput.focus();
          });
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      const opportunityLabel = {
        name: this.labelName,
        description: this.labelDescription,
        color: this.labelColor,
      };
      this.addOpportunityLabel(opportunityLabel)
        .then(() => {
          this.$toast.success(this.$t('page.admin-opportunity-labels.add-dialog.add-opportunity-label-success'));
          this.$emit('action-succeeded');
        })
        .catch((error) => this.$toast.error(error));
      this.closeDialog();
    },
    handleKeyup(event) {
      const keyCode = event.keyCode || event.charCode;

      if (keyCode === 13) {
        if (!this.isFormInvalid) this.onSubmit();
        return;
      }
    },
    cancelClick() {
      this.closeDialog();
    },
  },
  created() {
    document.addEventListener('keyup', this.handleKeyup);
  },
  destroyed() {
    document.removeEventListener('keyup', this.handleKeyup);
  },
};
</script>

<style lang="scss">
.base-dialog__add-opportunity-label {
  height: auto;
  width: 550px;
  position: relative;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    background: $color-white !important;
  }

  .close-icon__container {
    display: none;
  }
}

.add-opportunity-label {
  &__actions {
    margin-top: 32px;
    justify-content: flex-end;
    display: flex;
  }

  &__cancel {
    margin-right: 12px;
  }
}
</style>
